import { useContext } from 'react';
import { ReportBuilderFilters, ReportBuilderClientData } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { getAnswerClassificationSubTopicBreakdown } from 'services/answerClassificationBreakdown';
import { useAsyncEffect } from 'customHooks/hooks';
import {
  useDivisionIdsToFilterBy,
  useGroupByDepthLevel,
} from 'screens/WidgetGenerator/reportGeneratorComponents/hooks/useDivisionIdsToFilterBy';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { VaultAnswerClassificationSubTopicBreakdownResponse } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';

interface Props {
  filters: ReportBuilderFilters;
  clientData: ReportBuilderClientData;
}
export const useAnswerClassificationSubTopicBreakdown = ({
  filters,
  clientData,
}: Props): {
  fetchedData?: VaultAnswerClassificationSubTopicBreakdownResponse;
  isLoading: boolean;
  error?: Error;
} => {
  const { selectedSurveyGroup, selectedDateRange, client } = useContext(WidgetGeneratorContext);
  const divisionIdsToFilterBy = useDivisionIdsToFilterBy({ filters, clientData });
  const groupByDepthLevel = useGroupByDepthLevel({ filters, clientData });
  const selectedQuestionId = filters?.classifiedOpenEndedGenericQuestion;

  const fetchData = async () => {
    if (!selectedQuestionId) {
      return undefined;
    }

    const response = await getAnswerClassificationSubTopicBreakdown(client.zc_client_id, {
      survey_group: selectedSurveyGroup.id,
      generic_question: selectedQuestionId,
      start_date: selectedDateRange.startDate,
      end_date: selectedDateRange.endDate,
      division: divisionIdsToFilterBy,
      group_by_depth_level: groupByDepthLevel,
    });

    return response;
  };

  const { fetchedData, isLoading, error } = useAsyncEffect(fetchData, [
    selectedSurveyGroup,
    selectedQuestionId,
    selectedDateRange,
    divisionIdsToFilterBy,
  ]);

  return { fetchedData, isLoading, error };
};
